<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page="itemsPerPage"
            :loading="loading"
            hide-default-footer
            density="comfortable"
            color="typography2"
            class="elevation-1 custom-table rounded-md"
        >
            <template v-slot:loader>
                <v-progress-linear
                    :active="true"
                    color="typography2"
                    height="4"
                    indeterminate
                />
            </template>
            <template v-slot:item.calcInfo="{ item }">
                <div class="mb-2 mt-2">
                    {{ item.calcInfo.name }}
                    <br />
                    <span
                        class="text-medium-emphasis"
                        :style="{ fontSize: '0.75rem' }"
                    >
                        {{ item.calcInfo.namespace }}
                    </span>
                </div>
            </template>
            <template v-slot:item.persistentCalcId="{ item }">
                <v-btn
                    class="text-capitalize button"
                    rounded
                    size="small"
                    variant="outlined"
                    :to="`/persistentCalcs/${item.persistentCalcId}?posthog=functionPopularityCalcClick`"
                >
                    Open
                    <v-icon class="icon" color="secondary">
                        mdi-chevron-right
                    </v-icon>
                </v-btn>
            </template>
        </v-data-table>
    </div>
</template>
<script setup>
import { ref } from 'vue'

defineProps({
    items: Array,
    loading: Boolean,
    time: Number,
    itemsPerPage: Number,
})

const headers = ref([
    { title: 'Calculation', align: 'start', sortable: false, key: 'calcInfo' },
    { title: 'Library', align: 'start', sortable: false, key: 'library' },
    {
        title: 'Projects',
        align: 'start',
        sortable: false,
        key: 'totalProjects',
    },
    { title: 'Users', align: 'start', sortable: false, key: 'totalUsers' },
    { title: 'Calls', align: 'start', sortable: false, key: 'calls' },
    { title: '', align: 'start', sortable: false, key: 'persistentCalcId' },
])
</script>

<style scoped>
.custom-table {
    font-size: small !important;
}
</style>
